import { Buffer } from "buffer"
import { useState } from "react"
import { FiChevronRight } from "react-icons/fi"
import { useRecoilState, useSetRecoilState } from "recoil"
import { posCart } from "../config/atoms"
import { submitOrder } from "../functions/submitOrder"
import "./pos.css"

const deliveryFees = [
    //campus 5
    { n: "Campus", p: 5},
    //phaphala 15
    { n: "Phala-Phala", p: 15 },
    //jerusalema 15
    { n: "Jerusalema", p: 15 },
    //p west 15
    { n: "P-West", p: 15 },
    //maungani-next-to-gate 15
    { n: "Maungani Next To Gate", p: 15 },
    //maugani-aftergate 20 
    { n: "Maungani Aftergate", p: 20 },
    // golgotha 15
    { n: "Golgotha", p: 15 },
    //cosco 15
    { n: "Cosco", p: 15 },
    //little-star 15
    { n: "Little Star", p: 15 },
    //simeka 20
    { n: "Simeka", p: 20 },
    // grand royal 25
    { n: "Grand Royal", p: 25 },
    // forest hill 20
    { n: "Forest Hill", p: 20 },
    //river estate 30
    { n: "River Estate", p: 30 },
    // 3 MTR 30
    { n: "3 MTR", p: 15 },
    // j&R tour 20
    { n: "J&R Tour", p: 20 },
    // royal hill 25
    { n: "Royal Hill", p: 25 },
    //bervely hills 15
    { n: "Bervely Hills", p: 15 },
    //muthathe 25
    { n: "Muthathe", p: 25 },
    //emlanjeni 15
    { n: "Emplanjeni", p: 15 },
    //mapula res 15
    { n: "Mapula Res", p: 15 },
    //vhugalahawe 15
    { n: "Vhugalahawe", p: 15 },
    //west gate 10
    { n: "West Gate", p: 10 },
    //yellow-stone 15
    { n: "Yellow Stone", p: 15 },
    //green-stone 15
    { n: "Green Stone", p: 15 },
    //botanical garden 15
    { n: "Bonitical Gardens", p: 15 },
    //ngovhela res 15
    { n: "Ngovhela Red", p: 15 },
    //ngovhela-backside 30
    { n: "Ngovhela Backside", p: 15 },
    //sandton 15
    { n: "Sandton", p: 15 },
    //OGT 15
    { n: "OGT", p: 15 },
    //parkview 15
    { n: "Parkview", p: 15 },
    //pfunzo-house 15
    { n: "Punzo House", p: 15 },
    //thavhani-mall 15
    { n: "Thavhani Mall", p: 15 },
    // mulovhedzi 20
    { n: "Mulovhedzi", p: 15 },
    //p-ease 15
    { n: "P East", p: 15 },
    //mmemuthagu 20
    { n: "Mme-Muthagu", p: 20 },
    // pishon house 15
    { n: "Pishon House", p: 15 },
    //madrenis 15
    { n: "Magrenis", p: 15 },
    //makhode 15
    { n: "Makonde", p: 15 },
    //ngovhela hill side 30
    { n: "Ngovhela Hill Side", p: 30 },
    //tshilidzini 30
    { n: "Tshilidzini", p: 30 },
    //mvusuludzo 15
    { n: "Mvusuludzo", p: 15 },
    // plaza 15
    { n: "Plaza", p: 15 },
    //sibasa 25
    { n: "Sibasa", p: 25 },
    //makwarela 30
    { n: "Makwarela", p: 30 },
    //shayandima 30
    { n: "Shayandima", p: 30 },
    //muledane 25
    { n: "Muledane", p: 25 },
    //vhatanzi 30
    { n: "Vhatanzi", p: 30 },
]   

export function POSCart({ setLoading, printOrder, getTemplate, pairedDevice }) {

    const [checkout, setCheckout] = useState(false)

    const [cart, setCart] = useRecoilState(posCart)
    const [orderNumber, setOrderNumber] = useState(Number(localStorage.getItem("ordernumber") || 1) || 1)

    const [checkoutData, setCheckoutData] = useState({
        "title": "",
        "phone": "In Store Order",
        "status": "orderready",
        "date": new Date().toISOString(),
        "total": 0,
        "type": "sit-in",
        "address": {},
        "payment": "cash",
        "deliveryCharge": 0, 
        "amountInHand": 0,
        "charge": 0,
        "instore": true
    })

    async function addOrder() {
        try {

            setLoading(true)

            const orderTotal = cart.map(c => Number(c.price)).reduce((a,b, c) => a + b, 0)
            const total = orderTotal + (checkoutData?.type === "delivery" ? checkoutData.deliveryCharge : 0) + 2 + (checkoutData.payment === "Transfer + R5.00 Fee" ? 5 : 0)

            const order = {
                ...checkoutData,
                total: total,
                charge: total,
                note: (checkoutData.type === "delivery" ? (checkoutData.deliveryPlace + ": " + checkoutData.note) : ""),
                title: "#" + localStorage.getItem("ordernumber"),
                date: new Date().toISOString(), 
                items: cart,
            }

            const arr = await getTemplate(order)

            for await (const str of arr) {
                
                await pairedDevice.writeValue(Buffer.from(str + "\n", 'utf-8'));
    
            }

            await submitOrder(order)

            localStorage.setItem("ordernumber", JSON.stringify(orderNumber + 1))
            setOrderNumber(orderNumber + 1)
            setCheckoutData({
                "title": "",
                "phone": "In Store Order",
                "status": "orderready",
                "date": new Date().toISOString(),
                "total": 0,
                "type": "collect",
                "address": {},
                "payment": "cash",
                "deliveryCharge": 0, 
                "amountInHand": 0,
                "charge": 0,
                "instore": true
            })
            setCart([])
            setLoading(false)
            setCheckout(false)
            window.alert("Order Submited")
            
        } catch(err) {
            console.log(err)
            setLoading(false)
            window.alert("something went wrong: " + err.message)
        }
    }

    return (
        <>
            <div style={{ margin: 10 }}>
                <div style={{ margin: 10, padding: 10, backgroundColor: "var(--card)" }}>
                    <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                        <h2>Order #{orderNumber}</h2>
                    </div>
                </div>
                {cart.map((item, i) => (
                    <div className="services-item-wrapper" style={{ margin: '2px 10px' }} key={item.id}
                        onClick={() => setCart(c => c.filter((_, l) => l !== i))}
                    >
                        <div className="services-item-details" >
                            <p>{item.quantity} x {item.title}: <span style={{ color: 'var(--successColor)'}}>({item.sources.join(", ")})</span></p>
                            <p>R{Number(item.price)?.toFixed(2)}</p>
                        </div>
                        <div className="services-item-quantity" >
                            <h1>-</h1>
                        </div>
                    </div>
                ))}
                <div style={{ margin: 10, padding: 10, backgroundColor: "var(--card)" }}>
                    <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                        <h2>Items Total</h2>
                        <h2>R{cart.map(item => Number(item.price)).reduce((a,b,c) => a + b, 0).toFixed(2)}</h2>
                    </div>
                    <button onClick={() => setCheckout(true)}>
                        Check Out
                    </button>
                </div>
            </div>
            {checkout && <div className="backsplash">
                <div className="select-options">
                    <h3 style={{ marginBottom: 20 }}>Order Number #{orderNumber}</h3>
                    <hr/>
                    <p style={{ marginTop: 20, marginBottom: 10 }}>Payment Method</p>
                    <div>
                        <select value={checkoutData?.payment?.toLowerCase()}
                            onChange={e => setCheckoutData(c => ({ ...c, payment: e.target.value }))}
                        >
                            {["Card", "Transfer", "Cash"].map(option => (
                                <option label={option} value={option.toLowerCase()} />
                            ))}
                        </select>
                    </div>
                    {checkoutData.payment === "cash" && (
                        <>
                            <br/>
                            <div>
                                <input
                                    placeholder="Amount In Hand"
                                    type="number"
                                    value={checkoutData?.amountInHand || ''}
                                    onChange={e => setCheckoutData(c => ({ ...c, 
                                        amountInHand: e.target.value
                                    }))} 
                                />
                            </div>
                        </>
                    )}
                    <p style={{ margin: "10px 0"}}>Delivery Type</p>
                    <div>
                        <select
                            value={checkoutData?.type?.toLowerCase()}
                            onChange={e => setCheckoutData(c => ({ ...c, type: e.target.value }))} 
                        >
                            {["Sit-In", "Collect", "Delivery"].map(option => (
                                <option label={option} value={option?.toLowerCase()} />
                            ))}
                        </select>
                    </div>
                    <br/>
                    {checkoutData.type === "delivery" && (
                        <>
                            <div>
                                <select
                                    value={checkoutData?.deliveryPlace}
                                    onChange={e => setCheckoutData(c => ({ ...c, 
                                        deliveryCharge: Number(deliveryFees.find(c => c.n === e.target.value)?.p) ,
                                        deliveryPlace: e.target.value
                                    }))} 
                                >
                                    {deliveryFees.map(option => (
                                        <option label={option.n + ": + R" + option.p} value={option.n} />
                                    ))}
                                </select>
                            </div>
                            <br/>
                        </>
                    )}
                    <hr />
                    <br/>
                    <div >
                        {checkoutData.type === 'delivery' && <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                            <p>Delivery Fee</p>
                            <p>R{(checkoutData.deliveryCharge).toFixed(2)}</p>
                        </div>}
                        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                            <p>Order Total</p>
                            <p>R{(cart.map(item => Number(item.price)).reduce((a,b,c) => a + b, 0) + (checkoutData.payment === 'transfer' ? 5 : 0) + (checkoutData.type === 'delivery' ? checkoutData.deliveryCharge : 0)).toFixed(2)}</p>
                        </div>
                        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                            <p>{checkoutData.payment === "transfer" ? "Transfer Fee" : "Customer Change"}</p>
                            <p>R{checkoutData.payment === "transfer" ? "5.00" : (Number(checkoutData?.amountInHand) - cart.map(item => Number(item.price)).reduce((a,b,c) => a + b, 0)).toFixed(2)}</p>
                        </div>
                    </div>
                    <br/>
                    <div id="bt-connect-wrapper" style={{ margin: 0, padding: 0 }}>
                        <button 
                            onClick={() => {setCheckout(false)}}
                            style={{ backgroundColor: "var(--errorColor)", color: "#FFF", padding: '15px 0'}}
                        >
                            Cancel
                        </button>
                        <button 
                            style={{ backgroundColor: "var(--successColor)", color: "#FFF", padding: '15px 0'}}
                            onClick={addOrder}
                        >
                            Add Order & Print
                        </button>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default function POS({ services, width }) {

    const [selectedItem, setSelectedItem] = useState(null)
    const [sources, setSouces] = useState([])
    const [sides, setSides] = useState([])
    const [multiselect, setMultiselect] = useState(false)
    const [currect, setCurrect] = useState(0)
    const setPosCart = useSetRecoilState(posCart)

    function updateSources(selectedItem) {
        if(!selectedItem) {
            setSides([])
            setSouces([])
            setMultiselect(false)
            return false
        }

        if(["Chicken Meals", "Chicken Dust (only)", "Steak"].includes(selectedItem?.mainTitle?.trim())) {
            setSouces(["BBQ", "Mild", "Hot", "Extra Hot"])
            if(selectedItem?.mainTitle?.trim() !== "Chicken Dust (only)") {
                setSides(["Cabbage", "Chakalaka", "Salsa"])
            }
            setSelectedItem(c => ({ ...c, sources: ["BBQ"]}) )
            setMultiselect(false)
            return true
        }

        if(["Chips", "Kota meals"].includes(selectedItem?.mainTitle?.trim())) {
            setSouces(["BBQ", "Tomato", "Mustard", "No Sources"])
            setSelectedItem(c => ({ ...c, sources: ["BBQ", "Tomato", "Mustard"]}) )
            setMultiselect(true)
            return true
        }

        if(["Soft drinks"].includes(selectedItem?.mainTitle?.trim())) {

            if(selectedItem?.title.trim() === "Cans") {
                setSouces(["Coke", "Sprite", "Fanta Orange"])
                setSelectedItem(c => ({ ...c, sources: ["Coke"]}) )
            }

            if(selectedItem?.title.trim() === "My5") {
                setSouces(["Coke", "Sprite", "Stoney", "Fanta Orange"])
                setSelectedItem(c => ({ ...c, sources: ["Coke"]}) )
            }

            if(selectedItem?.title.trim() === "Other Flavours (2L)") {
                setSouces(["Coke", "Sprite", "Stoney", "Fanta Orange", "Fanta Grape"])
                setSelectedItem(c => ({ ...c, sources: ["Coke"]}) )
            }

            if(selectedItem?.title.trim() === "Lemon Twist") {
                setSouces(["Lemon Flavour"])
                setSelectedItem(c => ({ ...c, sources: ["Lemon Flavour"] }) )
            }

            if(selectedItem?.title.trim() === "Cappy") {
                setSouces(["Breakfast Blend", "Tropical"])
                setSelectedItem(c => ({ ...c, sources: ["Breakfast Blend"]}) )
            }

            return true
 
        }

        return false
    }

    function selectOption(option, multiselect) {
        let sel = []
        for (const itm of [ ...selectedItem.sources, option ]) {

            const i = itm

            sel = (["No Sources"].includes(i) || !multiselect) ? [i] : selectedItem.sources.includes(i) ? selectedItem.sources.filter(a => a !== i) : [ ...selectedItem.sources, i].filter(a => a !== "No Sources")
        }

        setSelectedItem(c => ({ ...c, sources: sel }))
    }

    function selectSides(option) {
        let sel = selectedItem.sources?.filter(c => sides.includes(c))
        let sources = selectedItem.sources?.filter(c => !sides.includes(c))

        if(sel.length === 2 || sel.includes(option)) {
            sel = sel.filter(itm => itm !== option)
        } else if(!sel.includes(option) && sel.length < 2) {
            sel = [ ...sel, option ]
        }
 
        setSelectedItem(c => ({ ...c, sources: [ ...sel, ...sources ] }))
    }

    return (
        <>
            <div id="pos-wrapper">
                {width > 768 && <div id="services-list">
                    {services?.map((service , i) => (
                        <div className="services-list-item" key={service.id}
                            style={{ 
                                borderBottomWidth: i === services.length - 1 ? 0 : 3,
                                backgroundColor: i === currect ? "var(--warnColor)" : 'transparent'
                            }}
                            onClick={() => setCurrect(i)}
                        >
                            <p style={{ paddingLeft: 10 }}>{service.title}</p>
                            <FiChevronRight size={20} />
                        </div>
                    ))}
                </div>}
                <div id="services-items-wrapper">
                    {((width <= 768) ? services : [services[currect]])?.map(service => (
                            <div className="services-wrapper" key={service?.id}>
                                {(width <= 768 ) && (
                                    <div className="service-header">
                                        <h2>{service.title}</h2>
                                    </div>
                                )}
                                <div className="services-items-wrapper">
                                    {service?.services?.map(item => (
                                        <div className="services-item-wrapper" 
                                            style={{
                                                borderLeft: "3px solid var(--warnColor)",
                                                borderLeftColor: item.show ? "var(--successColor)" : "var(--errorColor)"
                                            }}
                                            key={item?.id} onClick={() => {

                                                if(!item.show) return window.alert("Item not available")

                                                const selc = { ...item, mainTitle: service.title, sources: [] }

                                                const hasSources = updateSources(selc)

                                                if(hasSources) {
                                                    setSelectedItem({ ...selc, quantity: 1 })
                                                } else {
                                                    setPosCart(c => ([ ...c, { ...selc, quantity: 1 } ]))
                                                    updateSources(false)
                                                }

                                        }}>
                                            <div className="services-item-details" >
                                                <p>{item.title} <span style={{ color: item.show ? "var(--successColor)" : "var(--errorColor)"}}>({(item.show ? "Available" : "Not Available")})</span></p>
                                                <p>R{Number(item.price).toFixed(2)}</p>
                                            </div>
                                            <div className="services-item-quantity" >
                                                <h1>+</h1>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            {selectedItem !== null && <div className="backsplash">
                <div className="select-options">
                    <h3>Select Sources</h3>
                    <div className="options-wrapper">
                        {sources.map(option => (
                            <div className="service-option" key={option}
                                style={{
                                    backgroundColor: selectedItem?.sources?.includes(option) ? "var(--warnColor)" : "#fff"
                                }}
                                onClick={() => selectOption(option, multiselect)}
                            > 
                                <p>{option}</p>
                            </div>
                        ))}
                    </div>
                    {sides.length > 0 && (
                        <>
                            <h3>Select Sides</h3>
                            <div className="options-wrapper">
                                {sides.map(option => (
                                    <div className="service-option" key={option}
                                        onClick={() => selectSides(option, true)}
                                        style={{
                                            backgroundColor: selectedItem?.sources?.includes(option) ? "var(--warnColor)" : "#fff"
                                        }}
                                    >
                                        <p>{option}</p>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                    <br/>
                    <div id="bt-connect-wrapper" style={{ margin: 0, padding: 0 }}>
                        <button 
                            onClick={() => {
                                updateSources(null)
                                setSelectedItem(null)
                            }}
                            style={{ backgroundColor: "var(--errorColor)", color: "#FFF", padding: '15px 0'}}
                        >
                            Cancel
                        </button>
                        <button 
                            style={{ backgroundColor: "var(--successColor)", color: "#FFF", padding: '15px 0'}}
                            onClick={() => {
                                setPosCart(c => ([ ...c, selectedItem ]))
                                updateSources(null)
                                setSelectedItem(null)
                            }}
                        >
                            Add Item
                        </button>
                    </div>
                </div>
            </div>}
        </>
    )
}